var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyChartBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 142,
    viewBox: "0 0 564 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 140C30.5192 138.082 67.6519 101.457 91.5522 94.7318C106.693 92.3088 118.823 97.0247 132.357 104.352C145.89 111.68 143.241 114.844 173.677 120.494C198.795 125.155 205.365 74.8936 229.977 76.8247C254.589 78.7558 265.973 18.3256 291.958 23.3701C317.943 28.4145 323.135 15.3722 347.562 40.0902C371.988 64.8081 394.555 7.19223 425.218 2.14775C455.88 -2.89672 463.866 50.6445 478.418 48.6267C492.97 46.6089 506.072 84.7605 518.545 90.3094C531.018 95.8584 535.052 75.6238 561.557 75.6238",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChartBg);
export default __webpack_public_path__ + "static/media/_empty-chart-bg.1ac0b4572b87de0d49be4a1a5231bbde.svg";
export { ForwardRef as ReactComponent };